/* ==========================================================================
   GrandRanker Callout Rebuilder — Tiger Fitness (Shopify Plus)
   ==========================================================================
   Why this exists: GrandRanker pushes its "tip" blocks to Shopify as a
   plain paragraph — <p><strong>Pro Tip</strong>text with no space...</p> —
   with no class or wrapper to style. Confirmed directly from the live page
   HTML. CSS can't select an element by its text content, so this script
   finds those paragraphs by their known label text and rebuilds them into
   a styled card matching the boxes seen in the GrandRanker editor.

   Loaded only on the "grandranker" article template (see theme.liquid
   snippet in the setup instructions), same as the CSS file.
   ========================================================================== */

(function () {
  "use strict";

  // Map of label text (exactly as GrandRanker writes it) -> callout type.
  // Add more labels here if you spot others in future articles — send me
  // a screenshot or the label text and I'll fold it in here too.
  var LABELS = {
    "Pro Tip": "tip",
    "Key Takeaway": "takeaway",
    "Watch Out": "warning",
    "Quick Tip": "tip",
    "Warning": "warning",
    "Note": "note"
  };

  function rebuildCallouts(root) {
    var paragraphs = root.querySelectorAll(":scope > p");

    paragraphs.forEach(function (p) {
      var firstEl = p.firstElementChild;
      if (!firstEl || firstEl.tagName !== "STRONG") return;

      var labelText = firstEl.textContent.trim();
      var type = LABELS[labelText];
      if (!type) return;

      // Everything in the paragraph after the closing </strong>
      var bodyHTML = p.innerHTML.slice(firstEl.outerHTML.length).trim();

      var box = document.createElement("div");
      box.className = "gr-callout gr-callout--" + type;

      var heading = document.createElement("p");
      heading.className = "gr-callout__label";
      heading.textContent = labelText;

      var body = document.createElement("p");
      body.className = "gr-callout__body";
      body.innerHTML = bodyHTML;

      box.appendChild(heading);
      box.appendChild(body);

      p.replaceWith(box);
    });
  }

  function init() {
    var content = document.querySelector(".article--content");
    if (content) rebuildCallouts(content);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();